<template>
  <div class="pagination">
    <span>From {{ pagination_meta.from }} to {{ pagination_meta.to }} ({{ pagination_meta.total }}) on page {{ pagination_meta.current_page }} of {{ pagination_meta.last_page }} </span>
    <div class="pagination-links">
      <template v-for="(link, index) in pagination_meta.links" :key="'pagination-link-' + index">
        <RouterLink
          v-if="link.url"
          :class="{
            button: true,
            active: link.active
          }"
          v-bind:disabled="link.active"
          v-html="link.label"
          :to="buildLinkFromBackendUrl(link.url)"></RouterLink>
      </template>
    </div>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router'

export default {
  name: 'LoxPagination',
  components: { RouterLink },
  data() {
    return {}
  },
  props: {
    pagination_meta: {
      Object,
      default: null,
      required: false
    },
    prefix: {
      String,
      required: true
    }
  },
  methods: {
    getPageNumberFromUrl(url_string) {
      if (!url_string) {
        return null
      }
      let url = new URL(url_string)
      let params = new URLSearchParams(url.search)
      return params.get('page');
    },
    buildLinkFromBackendUrl(url_string)
    {
      return this.prefix + this.getPageNumberFromUrl(url_string)
    }

  }
}
</script>